import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {MySettingsCommonService} from '../../services/my-settings.common.service';
import {
  loadFormData,
  loadFormDataFailure,
  loadFormDataSuccess,
  updateFormData,
  updateFormDataFailure,
  updateFormDataSuccess
} from "../actions/my-settings.actions";
import {map, of, switchMap} from "rxjs";
import {catchError} from "rxjs/operators";

@Injectable()
export class MySettingsEffects {
  constructor(
    private actions$: Actions,
    private mySettingsCommonService: MySettingsCommonService
  ) {
  }

  loadFormData$ = createEffect(() => this.actions$.pipe(
    ofType(loadFormData),
    switchMap(() =>
      this.mySettingsCommonService.loadFormData().pipe(
        map((formData) => loadFormDataSuccess({formData})),
        catchError(() => of(loadFormDataFailure()))
      )
    )
  ))

  updateFormData$ = createEffect(() => this.actions$.pipe(
    ofType(updateFormData),
    switchMap(action =>
      this.mySettingsCommonService.updateFormData(action.payload).pipe(
        map(formData => {
          action.successFnc();
          return updateFormDataSuccess({formData});
        }),
        catchError(() => {
          action.failureFnc();
          return of(updateFormDataFailure());
        })
      )
    )
  ));


}
